import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AcceptInvite() {
  const { token } = useParams<{ token: string }>();
  const [inv, setInv] = useState<any>(null);
  const [err, setErr] = useState<string | null>(null);
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { refresh } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    api.get<{ invitation: any }>(`/auth/invite/${token}`)
      .then((r) => setInv(r.invitation))
      .catch((e) => setErr(e.message));
  }, [token]);

  if (err) return <div className="min-h-screen grid place-items-center text-brand">{err}</div>;
  if (!inv) return <div className="min-h-screen grid place-items-center text-ink-500">Loading…</div>;

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="card w-full max-w-sm p-6">
        <div className="text-center mb-6">
          <div className="text-2xl font-semibold">Join {inv.org_name}</div>
          <div className="text-sm text-ink-500">Invited as {inv.email}</div>
        </div>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            setBusy(true); setErr(null);
            try {
              await api.post("/auth/accept-invite", { token, name, password });
              await refresh();
              nav("/dashboard");
            } catch (e: any) { setErr(e.message); }
            finally { setBusy(false); }
          }}
          className="space-y-4"
        >
          <div>
            <label className="label">Your name</label>
            <input className="input" required value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div>
            <label className="label">Choose a password</label>
            <input className="input" type="password" minLength={8} required value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {err && <div className="text-sm text-brand">{err}</div>}
          <button className="btn-primary w-full" disabled={busy}>{busy ? "Joining…" : "Accept invite"}</button>
        </form>
      </div>
    </div>
  );
}
